import * as React from "react"
import { Box, HStack, Link, Text } from "@chakra-ui/react"

import { Limiter } from "./Limiter"

const tickerText = "Meld je nu aan voor de voorrondes van 2027!"

export function TickerBar() {
  return (
    <HStack
      top={0}
      right={0}
      left={0}
      zIndex={100}
      bgColor="yellow.500"
      w="100%"
      py={2}
      overflow="hidden"
      as={Link}
      href="https://www.kunstbende.nl/wedstrijd"
      position="absolute"
      role="banner"
      aria-label="Meld je nu aan voor de voorrondes van 2027"
      _hover={{ bgColor: "yellow.400", textDecoration: "none" }}
      _focusVisible={{ boxShadow: "outline" }}
    >
      <Limiter display={{ base: "none", md: "block" }}>
        <HStack justify="center" spacing={3} color="black">
          <Text fontWeight="black" textTransform="uppercase" letterSpacing="wide">
            {tickerText}
          </Text>
        </HStack>
      </Limiter>

      <Box display={{ base: "block", md: "none" }} w="100%" color="black" whiteSpace="nowrap">
        <Box
          display="inline-flex"
          minW="max-content"
          animation="tickerBarScroll 14s linear infinite"
          sx={{
            "@keyframes tickerBarScroll": {
              from: { transform: "translateX(0)" },
              to: { transform: "translateX(-50%)" },
            },
            "@media (prefers-reduced-motion: reduce)": {
              animation: "none",
              transform: "none",
            },
          }}
          aria-hidden="true"
        >
          {[...Array(2)].map((_, groupIndex) => (
            <Box key={groupIndex} display="inline-flex">
              {[...Array(3)].map((_, itemIndex) => (
                <Text
                  key={itemIndex}
                  as="span"
                  px={4}
                  fontWeight="black"
                  textTransform="uppercase"
                  letterSpacing="wide"
                >
                  {tickerText}
                </Text>
              ))}
            </Box>
          ))}
        </Box>
      </Box>
    </HStack>
  )
}
